import Splide from "@splidejs/splide";
import { verticalBuild } from "../layouts/vertical";
import { slideBuild } from "../layouts/slide";

require("../../../../../../themes/custom/wwf/js/src/utilities/objectValuesPolyfill");

/*
 * jQuery powered Quiz system
 *
 * Created by Tom Burr of Two Thirds Water www.twothirdswater.co.uk
 * Updated by WWF.
 */

/* eslint-disable prefer-rest-params */

(function quizBase($) {
  $.fn.ttw_quiz = function quizAction(actionOrOptions) {
    // Holds all defaults and overrides
    let settings;

    // Holds quiz progress
    const quiz = {
      totalQs: 0,
      answeredQs: 0,
      score: 0,
      questionsAnswered: [],
      questionsAnswers: [],
    };

    // Holds all methods
    const actions = {
      init(options) {
        // Save any options passed in
        settings = $.extend(
          {
            // These are the defaults
            wrapper: $(this),
            classprefix: "ttw_quiz_",
            showCorrectFeedback: true,
            showMediaShares: true,
            secretAnswers: false,
            initCallback() {},
            completeCallback() {},
            quizType: "instant",
            quizLayout: "vertical",
            questions: [
              {
                question: "Question one text?",
                answers: [
                  {
                    answer: "Answer 1",
                    feedback: "Answer 1 feedback",
                    correct: true,
                  },
                  {
                    answer: "Answer 2",
                    feedback: "Answer 2 feedback",
                  },
                  {
                    answer: "Answer 3",
                    feedback: "Answer 3 feedback",
                  },
                  {
                    answer: "Answer 4",
                    feedback: "Answer 4 feedback",
                  },
                ],
                image: false /* If image to be used add string of file path */,
                imageAlt: "",
                imageCredit: "",
                video: "",
              },
            ],
            resultsStrings: {
              incomplete: {
                title: "Please answer all questions to see your results",
                text: "Your score...",
              },
              complete: {
                title: "Results",
                text: "Quiz complete!",
                score: "You scored %score% out of %total%",
                feedbackTitle: {
                  0: "Must try harder",
                  2: "Could do better",
                  3: "Fantastic stuff",
                },
                feedbackText: {
                  0: "Must try harder",
                  2: "Could do better",
                  3: "Fantastic stuff",
                },
              },
            },
            leadText: "Tell your friends to join!",
            twitterShareText: "I got lots and lots!",
            whatsAppShareText: "I got lots and lots!Back",
            settings: {},
          },
          options
        );

        // Trigger build of quiz
        actions.initQuiz();
      },

      // Triggers building the quiz on screen before starting
      initQuiz() {
        if (settings.questions.length > 0) {
          if (settings.quizLayout === "vertical") {
            actions.buildVerticalQuiz();
          } else if (settings.quizLayout === "slide") {
            actions.buildSlideQuiz();
          }
          actions.addQuizEvents();
          actions.addStartOverEvent();

          // fire callback
          settings.initCallback.call(this);
        } else {
          $.error("No questions set on jQuery.ttw_quiz");
        }
      },

      // Builds Quiz HTML
      buildVerticalQuiz() {
        verticalBuild($, quiz, settings);
      },

      buildSlideQuiz() {
        slideBuild($, quiz, settings);
      },

      // Adds quiz Events
      addQuizEvents() {
        $(`.${settings.classprefix}question_unanswered`).on(
          "change",
          `.${settings.classprefix}answer_input`,
          function addQEvents(e) {
            e.preventDefault();
            actions.handleQuizAnswer($(this));
          }
        );
      },

      addStartOverEvent() {
        $(`.${settings.classprefix}start_over`).on(
          "click",
          function clearQuizEvent() {
            $("html, body").animate(
              { scrollTop: $(".ttw_quiz_wrapper").offset().top - 200 },
              1000,
              "swing"
            );
            actions.removeQuizWrapper();
            actions.resetQuestions();
            actions.initQuiz();
          }
        );
      },

      // Removes quiz wrapper element from the DOM
      removeQuizWrapper() {
        $(`.${settings.classprefix}wrapper`).empty();
      },

      // Prevents quiz scores from being carried over
      resetQuestions() {
        quiz.answeredQs = 0;
        quiz.score = 0;
        quiz.questionsAnswered = [];
        quiz.questionsAnswers = [];
        quiz.totalQs = 0;
      },

      // Removes a single questions change events
      removeQuizQuestionEvent(questionElement) {
        questionElement.off("change", `.${settings.classprefix}answer_input`);
      },

      // Does all the quiz magic when an answer is provided
      handleQuizAnswer(answerElement) {
        const questionElement = answerElement.closest(
          `.${settings.classprefix}question`
        );
        const answerParentElement = answerElement.closest(
          `.${settings.classprefix}answer`
        );
        const answerLetterText =
          answerParentElement[0].lastChild.firstChild.firstChild;

        // Handle styling changes
        questionElement.removeClass(
          `${settings.classprefix}question_unanswered`
        );
        questionElement.addClass(`${settings.classprefix}question_answered`);

        const thisMark = actions.markAnswer(
          answerParentElement.data("question-id"),
          answerParentElement.data("answer-id")
        );

        if (settings.quizType === "instant") {
          actions.removeQuizQuestionEvent(questionElement);
          questionElement
            .find(`.${settings.classprefix}answer_input`)
            .attr("disabled", true);

          answerParentElement.addClass(
            `${settings.classprefix}answer_selected`
          );

          if (thisMark === true) {
            // Mark this answer as correct
            answerParentElement.addClass(
              `${settings.classprefix}answer_correct`
            );
            answerLetterText.innerHTML = "&#10004;";

            // Display feedback
            actions.displayAnswerFeedback(answerParentElement);

            // Update the quiz record
            actions.updateQuiz(true);
          } else {
            // As the answer chosen was incorrect thisMark contains the correct answer index
            const correctQuestionElement = questionElement
              .find(`.${settings.classprefix}answer`)
              .eq(thisMark);

            // So show this answer as being correct
            correctQuestionElement.addClass(
              `${settings.classprefix}answer_correct`
            );
            correctQuestionElement[0].lastChild.firstChild.firstChild.innerHTML =
              "&#10004;";

            // Mark the chosen answer as incorrect
            answerParentElement.addClass(
              `${settings.classprefix}answer_incorrect`
            );
            answerLetterText.innerHTML = "&#10008;";

            // Display feedback to both correct and incorrect answer
            actions.displayAnswerFeedback(answerParentElement);

            if (settings.showCorrectFeedback) {
              actions.displayAnswerFeedback(correctQuestionElement);
            }

            // Update the quiz record
            actions.updateQuiz();
          }
        } else if (settings.quizType === "wait") {
          if (settings.quizLayout === "slide") {
            $(questionElement)
              .find(`.ttw_quiz_slide-answer-container`)
              .children()
              .each(function answerSelect(key, value) {
                $(value).removeClass(`${settings.classprefix}answer_selected`);
              });
          } else {
            $(questionElement)
              .find(`.${settings.classprefix}answers`)
              .children()
              .each(function answerSelect(key, value) {
                $(value).removeClass(`${settings.classprefix}answer_selected`);
              });
          }
          const answerLetterTextWait =
            answerParentElement[0].lastChild.firstChild.firstChild;
          answerLetterTextWait.innerHTML = `
          <svg width="22" height="23">
            <circle cx="10" cy="14" r="9" fill="#FEC01E" />
            <circle cx="10" cy="14" r="6" fill="#000" />
            <circle cx="10" cy="14" r="3" fill="#FEC01E"/>
          </svg>
        `;

          answerParentElement.addClass(
            `${settings.classprefix}answer_selected`
          );

          const answerSiblings = answerParentElement.siblings();

          $(answerSiblings).each(function () {
            const inputEl = this.firstChild;
            $(inputEl).prop("disabled", true);
            $(this).addClass("sibling-answer-opacity");
          });

          actions.updateQuiz(
            thisMark === true,
            questionElement.attr("question")
          );
        }
      },

      // Mark question - returns true if it is correct and the correct index if it isn't
      markAnswer(question, answer) {
        if (settings.questions[question].answers[answer].correct === true) {
          return true;
        }
        for (let i = 0; i < settings.questions[question].answers.length; i++) {
          if (settings.questions[question].answers[i].correct === true) {
            return i;
          }
        }
      },

      // Displays feedback in answer
      displayAnswerFeedback(answerElement) {
        const myFeedback = actions.getAnswerFeedback(
          answerElement.data("question-id"),
          answerElement.data("answer-id")
        );
        const myFeedbackElement = $("<span></span>")
          .addClass(`${settings.classprefix}answer_feedback`)
          .text(myFeedback);
        answerElement
          .find(`.${settings.classprefix}answer_text`)
          .append(myFeedbackElement);
      },

      // Returns the feedback string for any given question / answer
      getAnswerFeedback(question, answer) {
        return settings.questions[question].answers[answer].feedback;
      },

      // Update the quiz record now a question has been answered
      updateQuiz(correct, question) {
        if (
          settings.quizType === "wait" &&
          quiz.questionsAnswered.indexOf(question) === -1
        ) {
          // a question has been answered
          quiz.answeredQs += 1;
          quiz.questionsAnswered.push(question);
        } else if (settings.quizType === "instant") {
          quiz.answeredQs += 1;
        }

        // Was it a correct answer?
        if (settings.quizType === "instant" && correct) {
          quiz.score += 1;
        } else if (settings.quizType === "wait") {
          const answers = Object.values(quiz.questionsAnswers);
          const current = answers.filter(function answerValidation(value) {
            return value.question === question;
          });

          if (current) {
            current.answer = correct;
            quiz.questionsAnswers.splice(question, 0, current);
          } else {
            quiz.questionsAnswers.push({
              question,
              answer: correct,
            });
          }
        }

        if (quiz.answeredQs >= quiz.totalQs) {
          if (settings.quizType === "wait") {
            quiz.score = quiz.questionsAnswers.filter(function answerValue(
              value
            ) {
              return value.answer === true;
            }).length;
          }

          actions.quizComplete();
        }
      },

      // When all questions are answered show the results
      quizComplete() {
        if (settings.quizLayout === "slide") {
          const progressBarInfoText = document.querySelector(
            ".splide_progress_info_text"
          );
          progressBarInfoText.innerHTML = "Quiz complete";

          const backBtn = $(".splide__arrow--prev");
          backBtn.addClass("hide_back_btn");
        }

        // Show the results
        actions.displayResults();

        if (settings.quizType === "wait") {
          if (settings.secretAnswers !== true) {
            actions.updateQuizColours();
          }

          $(`.${settings.classprefix}answer_input`).attr("disabled", true);

          $(`.${settings.classprefix}question`).each(function removeQuestion(
            index,
            value
          ) {
            actions.removeQuizQuestionEvent($(value));
          });
        }

        // Fire callback
        settings.completeCallback.call(this);
        Drupal.behaviors.sourceCodeScourer.attach();
      },

      // Show the results
      displayResults() {
        // Update results styling
        const resultsElement = $(`.${settings.classprefix}results`).removeClass(
          `${settings.classprefix}results_incomplete`
        );

        // Update results title, text and image
        resultsElement
          .find(`.${settings.classprefix}results_container`)
          .remove(`.${settings.classprefix}results_container`);
        resultsElement
          .find(`.${settings.classprefix}results_image_container`)
          .remove(`.${settings.classprefix}results_image_container`);
        resultsElement
          .find(`.${settings.classprefix}results_title`)
          .remove(`.${settings.classprefix}results_title`);
        resultsElement
          .find(`.${settings.classprefix}results_title_container`)
          .remove(`.${settings.classprefix}results_title_container`);
        resultsElement
          .find(`.${settings.classprefix}results_text`)
          .remove(`.${settings.classprefix}results_text`);
        resultsElement
          .find(`.${settings.classprefix}results_text_container`)
          .remove(`.${settings.classprefix}results_text_container`);

        const completedResultsElement = $("<div></div>").addClass(
          `${settings.classprefix}results_completed`
        );
        resultsElement.append(completedResultsElement);

        const scoreContainer = $("<div></div>").addClass(
          `${settings.classprefix}results_score_container`
        );
        completedResultsElement.append(scoreContainer);

        // Add score
        scoreContainer.append(
          $("<p></p>")
            .addClass(`${settings.classprefix}results_score`)
            .text(
              settings.resultsStrings.complete.score
                .replace("%score%", quiz.score)
                .replace("%total%", quiz.totalQs)
            )
        );

        // Add feedback
        const feedbackContainer = $("<div></div>").addClass(
          `${settings.classprefix}results_feedback_container`
        );
        completedResultsElement.append(feedbackContainer);

        // Work out what feedback to show
        let feedbackString = "";
        let i = quiz.score;
        let feedbackImageUrl = "";

        // Add feedback text and title container
        const feedbackTextContainer = $("<div></div>").addClass(
          `${settings.classprefix}results_feedback_text_container`
        );
        feedbackContainer.append(feedbackTextContainer);

        // Check for feedback title
        if (settings.resultsStrings.complete.feedbackTitle !== undefined) {
          while (i >= 0) {
            if (i in settings.resultsStrings.complete.feedbackTitle) {
              feedbackString =
                settings.resultsStrings.complete.feedbackTitle[i];
              break;
            }
            i -= 1;
          }
          // Add feedback
          feedbackTextContainer.append(
            $("<p></p>")
              .addClass(`${settings.classprefix}results_feedback_title`)
              .append(feedbackString)
          );
        }

        // Check for feedback text
        if (settings.resultsStrings.complete.feedbackText !== undefined) {
          while (i >= 0) {
            if (i in settings.resultsStrings.complete.feedbackText) {
              feedbackString = settings.resultsStrings.complete.feedbackText[i];
              break;
            }
            i -= 1;
          }
          // Add feedback text
          feedbackTextContainer.append(
            $("<p></p>")
              .addClass(`${settings.classprefix}results_feedback_text`)
              .append(feedbackString)
          );
        }

        // Check for slide feedback image
        if (settings.quizResultsImg) {
          feedbackContainer.addClass("has_image");

          const resultsImgContainer = $("<div></div>")
            .addClass(`${settings.classprefix}results_image_container`)
            .attr("id", `${settings.classprefix}anchor`);

          const resultsImg = $("<img />")
            .attr("src", settings.quizResultsImg)
            .attr(
              "alt",
              `An image to indicate you haven't yet completed the quiz`
            );

          const resultsImgCredit = $("<span></span>")
            .addClass(`${settings.classprefix}question_image_credit`)
            .html(settings.quizResultsImgCredit);

          resultsImgContainer.append(resultsImg, resultsImgCredit);
          completedResultsElement.append(resultsImgContainer);
        }

        // Check for vertical feedback image
        if (settings.resultsStrings.complete.feedbackImage !== undefined) {
          while (i >= 0) {
            if (i in settings.resultsStrings.complete.feedbackImage) {
              feedbackImageUrl =
                settings.resultsStrings.complete.feedbackImage[i];
              break;
            }
            i -= 1;
          }
          // Add feedback text
          feedbackContainer.addClass("has_image");
          feedbackContainer.append(
            $("<div></div>")
              .addClass(`${settings.classprefix}results_feedback_img_container`)
              // .append(feedbackImageUrl)
              .html(
                `<img src="${feedbackImageUrl}" alt="An image to say ${settings.resultsStrings.complete.feedbackTitle}." />`
              )
          );
        }

        // Append score container to feedback container if slide layout
        if (settings.quizLayout === "slide") {
          feedbackContainer.prepend(scoreContainer);
        }

        /* (Matt) It would be tidy to delete the social buttons code, but I'll
        keep it in case we decide to use the hyperlinks with icons in the
        future */

        // Social buttons
        // if (settings.showMediaShares === true) {
        //   resultsElement.append(
        //     $("<span></span>")
        //       .addClass(`${settings.classprefix}results_social`)
        //       .addClass(`${settings.classprefix}slide-padding`)
        //       .append(
        //         `<a class="btn btn--3 share--twitter js-promise-sharer" data-share="twitter" ga-event-action="Click" ga-event-category="SimpleQuizShare" ga-event-label="Twitter Share" ga-on="click" href="https://twitter.com/intent/tweet?text=${encodeURIComponent(
        //           settings.twitterShareText
        //             .replace("%score%", quiz.score)
        //             .replace("%total%", quiz.totalQs)
        //         )}" target="_blank">Twitter </a> <a class="btn btn--facebook share--facebook js-promise-sharer" data-share="facebook" ga-event-action="Click" ga-event-category="SimpleQuizShare" ga-event-label="Facebook Share" ga-on="click" href="https://www.facebook.com/sharer/sharer.php?u=${
        //           window.location.href
        //         }" target="_blank"> Facebook </a> <a class="btn btn--whatsapp" href="https://web.whatsapp.com/send?text=${encodeURIComponent(
        //           settings.whatsAppShareText
        //             .replace("%score%", quiz.score)
        //             .replace("%total%", quiz.totalQs)
        //         )}" target="_blank">WhatsApp </a> `
        //       )
        //   );
        // }

        if (settings.leadText !== undefined) {
          feedbackTextContainer.append(
            `<p id="${settings.classprefix}lead_text" class="${settings.classprefix}results_feedback_text">${settings.leadText}</p>`
          );
        }
      },
      updateQuizColours() {
        $(".ttw_quiz_answer").each(function answerUpdate(index, value) {
          const answerParentElement = $(
            value.closest(`.${settings.classprefix}answer`)
          );

          const correct = actions.markAnswer(
            answerParentElement.data("question-id"),
            answerParentElement.data("answer-id")
          );

          const answerLetterText =
            answerParentElement[0].lastChild.firstChild.firstChild;

          if (correct === true) {
            answerParentElement.addClass(
              `${settings.classprefix}answer_correct`
            );
            answerParentElement.removeClass("sibling-answer-opacity");
            answerLetterText.innerHTML = "&#10004;";
          } else if (
            answerParentElement.hasClass(
              `${settings.classprefix}answer_selected`
            )
          ) {
            answerParentElement.addClass(
              `${settings.classprefix}answer_incorrect`
            );
            answerLetterText.innerHTML = "&#10008;";
          }
        });
      },
    };

    function buildSlider() {
      const quizSliders = $("*.ttw_quiz_slider_wrapper");
      quizSliders.each((index, slider) => {
        const quizSlider = new Splide(slider.querySelector(".splide"), {
          type: "fade",
          pagination: false,
          drag: false,
          easing: "ease",
          lazyLoad: "nearby",
        });
        quizSlider.mount();

        // Set progress bar info
        // Select elements
        const progressBarInfoCurrent = quizSlider.root.querySelector(
          ".splide_progress_info_current"
        );
        const progressBarInfoTotal = quizSlider.root.querySelector(
          ".splide_progress_info_total"
        );
        const progressBarCurrent = quizSlider.root.querySelector(
          ".splide_progress_bar_current"
        );

        // Assign dynamic values
        progressBarInfoCurrent.innerHTML = quizSlider.index + 1;
        progressBarInfoTotal.innerHTML = quizSlider.length - 1;
        progressBarCurrent.style.width = `${
          ((quizSlider.index + 1) / (quizSlider.length - 1)) * 100
        }%`;

        quizSlider.on("moved", () => {
          progressBarInfoCurrent.innerHTML = quizSlider.index + 1;
          progressBarInfoTotal.innerHTML = quizSlider.length - 1;
          progressBarCurrent.style.width = `${
            ((quizSlider.index + 1) / (quizSlider.length - 1)) * 100
          }%`;

          if (quizSlider.index + 1 > quizSlider.length - 1) {
            progressBarInfoCurrent.innerHTML = quizSlider.length - 1;
            progressBarCurrent.style.width = "100%";
          }
        });

        // Add mousedown events to each answer to make the slider move to the next question
        // const slides =
        //   quizSlider.root.firstElementChild.nextElementSibling.firstElementChild
        //     .children;
        //
        // $.each(slides, function (key, slide) {
        //   const answers = slide.querySelectorAll(".ttw_quiz_answer");
        //   $.each(answers, function (k, answer) {
        //     answer.addEventListener("mousedown", function () {
        //       setTimeout(() => {
        //         quizSlider.go(quizSlider.index + 1);
        //       }, 500);
        //     });
        //   });
        // });

        // Splide on moved event to change text of next button
        quizSlider.on("moved", () => {
          const currentNextBtn = $(".splide__arrow--next");
          if (quizSlider.index + 1 === quizSlider.length - 1) {
            currentNextBtn.html("Get results");
            currentNextBtn.off();
          } else if (quizSlider.index + 1 === quizSlider.length) {
            currentNextBtn.html("Start over").attr("disabled", false);
            currentNextBtn.on("click", function slideQuizStartOver() {
              actions.removeQuizWrapper();
              actions.resetQuestions();
              actions.initQuiz();
              buildSlider();
            });
          } else {
            currentNextBtn.html("Next question");
            currentNextBtn.off();
          }
        });
      });
    }

    // Splide slider for quiz
    $(document).ready(() => {
      buildSlider();
    });

    function actionFunction(action, ...args) {
      return action.apply(this, args); // or `action(...args)`, related to the `prefer-spread` rule.
    }

    if (actions[actionOrOptions]) {
      actionFunction(actions[actionOrOptions]);
    }

    if (typeof actionOrOptions === "object" || !actionOrOptions) {
      return actions.init.apply(this, arguments);
    }

    $.error(`Action ${actionOrOptions} does not exist on jQuery.ttw_quiz`);
  };
})(jQuery);
